import DgModal from "../../../custom/feedback/modal";
import {useDispatch, useSelector} from "react-redux";
import {onChangeVisibleDrawerAdmin} from "../../../redux/actions/layout/interaction/action";
import Add from "./add";
import {useState} from "react";

const AddParent = ()=>{

    const dispatch = useDispatch()
    const {visibleDrawerAdmin} = useSelector(state => state.layoutInteractionReducer)
    const [loading , setLoading] = useState(false)

    return (
        <DgModal visible={visibleDrawerAdmin==="weightStation"}
                  width={600}
                  onCancel={() => dispatch(onChangeVisibleDrawerAdmin(undefined))}
                  title={"Tạo mới trạm cân "}
                  bodyStyle={{
                      minHeight: 100,
                      maxHeight: 600,
                      overflowY: "scroll",
                  }}
                  destroyOnClose={true}
                  okText={"Tạo mới"}
                  loading={loading}>
            <Add onLoading={(value)=>setLoading(value)} />
        </DgModal>
    )
}

export default AddParent
